<template lang="pug">
div
    .colunas__card.col-12.p-0.mb-3
        .card-totalizadores-dashboard-laudos__card
            span.card-totalizadores-dashboard-laudos__descricao {{ $t('laudos.solicitados') }}
            span.card-totalizadores-dashboard-laudos__total {{ dados.solicitados }}
        .card-totalizadores-dashboard-laudos__card
            span.card-totalizadores-dashboard-laudos__descricao {{ $t('laudos.naFila') }}
            span.card-totalizadores-dashboard-laudos__total {{ dados.naFila }}
        .card-totalizadores-dashboard-laudos__card
            span.card-totalizadores-dashboard-laudos__descricao {{ $t('laudos.emProcessamento') }}
            span.card-totalizadores-dashboard-laudos__total {{ dados.emProcessamento }}
        .card-totalizadores-dashboard-laudos__card
            span.card-totalizadores-dashboard-laudos__descricao {{ $t('laudos.processados') }}
            span.card-totalizadores-dashboard-laudos__total {{ dados.processados }}
        .card-totalizadores-dashboard-laudos__card
            span.card-totalizadores-dashboard-laudos__descricao {{ $t('laudos.cancelado') }}
            span.card-totalizadores-dashboard-laudos__total {{ dados.cancelado }}
        .card-totalizadores-dashboard-laudos__card
            span.card-totalizadores-dashboard-laudos__descricao {{ $t('laudos.falhasNoProcessamento') }}
            span.card-totalizadores-dashboard-laudos__total {{ dados.falhaProcessamento }}
</template>
<script>
export default {
    name: 'CardTotalizadores',
    props: {
        dados: {
            type: Object,
            required: true
        }
    }
};
</script>
<style lang="scss" scoped>
.card-totalizadores-dashboard-laudos__card {
    display: flex;
    flex-direction: row;
    height: 100px;
    border-radius: 5px;
    background-color: var(--white);
    border: solid 1px var(--default-border-color);
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    padding: 0 20px;
    text-align: center;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 1px;
    position: relative;

    .card-totalizadores-dashboard-laudos__total {
        color: var(--primary);
        font-size: 26px;
        font-weight: 600;
        width: 30%;
        text-align: left;
        margin-right: 5px;
    }

    .card-totalizadores-dashboard-laudos__descricao {
        color: var(--primary);
        font-size: 16px;
        font-weight: 500;
        padding-bottom: 0;
        text-align: left;
        width: 70%;
    }
}
</style>
